import { CachedItem } from "@lib-shared/lib";
import { Key } from "core/constants";
import { getErrorMessage, logApiError } from "core/lib";
import { StatementService } from "core/services/cef";
import LatestStatementsStore from "./latest-statements.store";

class LatestStatementsStoreManager {
    store: LatestStatementsStore;

    private _cache = new CachedItem(Key.latestStatements);

    constructor(store: LatestStatementsStore) {
        this.store = store;
    }

    reset() {
        console.log("Resetting");
        this._cache.clear();
        this.store.reset();
    }

    populateAsync = async () => {
        if (this.store.isLoading) {
            return;
        }

        this.store.updateIsLoading(true);

        if (this._cache.isCached) {
            const cachedValue = this._cache.value;
            this.store.updateLatestStatement(cachedValue);
            this.store.updateIsLoading(false);
            return;
        }

        try {
            console.log("Fetching latest statements");
            const response = await new StatementService().getRecentStatements();

            const data = response.data;

            const statement = data.length ? data[0] : null;;

            this.store.updateLatestStatement(statement);
            this._cache.set(statement);
        } catch (error) {
            logApiError(error);

            const firstError = getErrorMessage(error);

            this.store.updateHasError(true, firstError);
        }

        this.store.updateIsLoading(false);
    };
}

export default LatestStatementsStoreManager;
